import React from 'react'
import { Box } from '@mui/material'
import { DateField } from '@mui/x-date-pickers/DateField'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { DateRangeCalendar } from '@mui/x-date-pickers-pro/DateRangeCalendar'
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider'
import { type Dayjs } from 'dayjs'

export interface DateRangePanelProps {
  startDate: Dayjs | null
  endDate: Dayjs | null
  onChange: (startDate: Dayjs | null, endDate: Dayjs | null) => void
}

const DateRangePanel: React.FC<DateRangePanelProps> = ({ startDate, endDate, onChange }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box className='filter-date-inputs'>
      <DateField
        label='Start Date'
        format='MM/DD/YYYY'
        value={startDate}
        onChange={(newValue: Dayjs | null) =>
          onChange(newValue?.isValid() ? newValue : null, endDate)
        }
        size='small'
      />
      <DateField
        label='End Date'
        format='MM/DD/YYYY'
        value={endDate}
        onChange={(newValue: Dayjs | null) =>
          onChange(startDate, newValue?.isValid() ? newValue : null)
        }
        size='small'
      />
    </Box>
    <Box className='filter-date-picker'>
      <DateRangeCalendar
        value={[startDate, endDate]}
        onChange={(newValue) => onChange(newValue[0] ?? null, newValue[1] ?? null)}
        calendars={1}
      />
    </Box>
  </LocalizationProvider>
)

export default DateRangePanel
